module.exports = __webpack_public_path__ + "img/sbg1.b03186bf.jpg";